// @flow
import * as React from "react";
import styled from "styled-components";

const Svg = styled.svg`
  width: 18px;
  height: 18px;
  cursor: pointer;
  fill-rule: evenodd;
  fill: ${props => props.theme.helpdeskNavlinks};

  @media (min-width: 960px) {
    width: 24px;
    height: 24px;
    fill: rgb(255, 255, 255);

    :hover {
      fill: ${props => props.theme.accent};
    }
  }
`;

const BackSvg = styled(Svg)`
  width: 26px;
  margin-left: 14px;
  margin-right: 5px;
`;

const UnitedSearchSvg = styled.svg`
  width: 16px;
  height: 16px;
  cursor: pointer;
  fill-rule: evenodd;
  fill: ${props => props.theme.staticHeaderLink};

  :hover {
    fill: ${props => props.theme.accent};
  }
`;

export const SearchIcon = (props: {}) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M22.578,20.798 L18.567,16.846 C19.755,15.201 20.460,13.195 20.460,11.027 C20.460,5.468 15.870,0.947 10.228,0.947 C4.587,0.947 -0.003,5.468 -0.003,11.027 C-0.003,16.584 4.587,21.106 10.228,21.106 C12.585,21.106 14.751,20.310 16.483,18.986 L20.450,22.894 C20.744,23.183 21.130,23.328 21.514,23.328 C21.899,23.328 22.284,23.184 22.578,22.894 C23.166,22.316 23.166,21.377 22.578,20.798 ZM2.405,11.027 C2.405,6.777 5.915,3.319 10.229,3.319 C14.543,3.319 18.053,6.777 18.053,11.027 C18.053,12.795 17.440,14.422 16.419,15.724 C16.081,16.154 15.702,16.551 15.281,16.902 C13.917,18.043 12.155,18.735 10.229,18.735 C5.915,18.734 2.405,15.277 2.405,11.027 Z" />
  </Svg>
);

export const UnitedSearchIcon = (props: {}) => (
  <UnitedSearchSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="213 3409 15.9 15.9"
    {...props}
  >
    <path
      d="M15.9,14.5l-3.3-3.3A6.847,6.847,0,0,0,14,7,6.957,6.957,0,0,0,7,0,6.957,6.957,0,0,0,0,7a6.957,6.957,0,0,0,7,7,6.847,6.847,0,0,0,4.2-1.4l3.3,3.3ZM2,7A4.951,4.951,0,0,1,7,2a4.951,4.951,0,0,1,5,5,4.951,4.951,0,0,1-5,5A4.951,4.951,0,0,1,2,7Z"
      transform="translate(213 3409)"
    />
  </UnitedSearchSvg>
);

export const UnitedSearchCloseIcon = (props: {}) => (
  <UnitedSearchSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="167 4126 15.557 15.557"
    {...props}
  >
    <path
      d="M7.778,9.192,1.414,15.557,0,14.142,6.364,7.778,0,1.414,1.414,0,7.778,6.364,14.142,0l1.415,1.414L9.192,7.778l6.364,6.364-1.415,1.415Z"
      transform="translate(167 4126)"
    />
  </UnitedSearchSvg>
);

export const BackIcon = (props: {}) => (
  <BackSvg
    xmlns="http://www.w3.org/2000/svg"
    width="19px"
    height="16px"
    viewBox="0 0 19 16"
    {...props}
  >
    <path d="M7.543,0.485 L0.741,7.287 C0.345,7.683 0.345,8.326 0.741,8.722 L7.543,15.524 C7.939,15.920 8.582,15.920 8.978,15.524 C9.374,15.127 9.374,14.485 8.978,14.088 L3.886,8.997 L17.472,8.997 C18.032,8.997 18.487,8.543 18.487,7.982 C18.487,7.422 18.032,6.968 17.472,6.968 L3.931,6.968 L8.978,1.920 C9.374,1.524 9.374,0.882 8.978,0.485 C8.582,0.089 7.939,0.089 7.543,0.485 Z" />
  </BackSvg>
);



// WEBPACK FOOTER //
// ./src/components/Helpdesk/Icons.js